document.addEventListener('DOMContentLoaded', function () {
  var wrappers = document.querySelectorAll('.hero__media-wrapper');
  if (wrappers.length < 2) return;
  var media2 = wrappers[1]; // second wrapper = right side

  media2.innerHTML =
    '<div class="jc-hero-panel">' +
    '<img src="https://cdn.shopify.com/s/files/1/0765/1252/6503/files/jc-logo-darkred-cropped.png?v=1787481047" alt="Jewels Crest" class="jc-hero-mark-img">' +
      '<span class="jc-hero-line">NEW IN | ONE OF A KIND</span>' +
      '<a href="/collections/earth-tide" class="jc-hero-btn">shop the collection</a>' +
    '</div>';
});
